import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { productsResolver } from './core/resolvers/products.resolver';

export const routes: Routes = [
  {
    path: 'users/details/:id',
    loadComponent: () =>
      import('./features/users/pages/user-detail/user-detail').then(
        (m) => m.UserDetail,
      ),
    canActivate: [authGuard],
    resolve: { products: productsResolver },
  },
  {
    path: 'products',
    loadComponent: () =>
      import('./features/products/pages/product-list/product-list').then((m) => m.ProductList),
    canActivate: [authGuard],
    resolve: { products: productsResolver },
  },
  {
    path: 'roles',
    loadComponent: () => import('./features/roles/pages/role-list/role-list').then((m) => m.RoleList),
    canActivate: [authGuard],
    resolve: { products: productsResolver },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./core/auth/pages/login/login').then((m) => m.Login),
  },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard').then((m) => m.Dashboard),
    canActivate: [authGuard],
  },

  {
    path: 'users',
    loadComponent: () =>
      import('./features/users/pages/user-list/user-list').then((m) => m.UserList),
    canActivate: [authGuard],
    resolve: { products: productsResolver },
  },

  {
    path: 'audit',
    loadComponent: () =>
      import('./features/audit/audit').then((m) => m.Audit),
    canActivate: [authGuard],
  },

  {
    path: 'settings',
    loadComponent: () =>
      import('./features/settings/settings').then((m) => m.Settings),
    canActivate: [authGuard],
  },

  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },

  // Wildcard route
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
